import { Component } from '@angular/core';
import { AppConfigService } from 'src/app/Services/app-config.service';
import { EmployeeloginService } from 'src/app/Services/employeelogin.service';
import { SessionvalidateService } from 'src/app/Services/sessionvalidate.service';
import { Router } from '@angular/router';
import { CafeMenuService } from 'src/app/Services/cafe-menu.service';
import { CafeMenuNamesService } from 'src/app/Services/cafe-menu-names.service';
import { UserData, EmployeeData } from 'src/app/Models/employee-and-user-data';

type cafemenunameInfo = {
  slnuid: number;
  slnshpid: number;
  shpShipName: string;
  slnName: string;
  slnDefault: boolean;
  slnltyuid: number;
  ltyname: string;
};

@Component({
  selector: 'app-meal-activity-page',
  templateUrl: './meal-activity-page.component.html',
  styleUrls: ['./meal-activity-page.component.css'],
  providers: [CafeMenuService, CafeMenuNamesService],
})
export class MealActivityPageComponent {
  imagepath = '';
  userdata?: UserData;
  validsession: boolean | undefined;
  LoginData: any;
  employeeData?: EmployeeData;
  shpId: number | undefined;

  // American Harmony Back Porch Cafe
  // slnshpid: number | undefined;
  // ltyname: string = '';
  // slnshpid = 4;
  ltyname = 'Cafe';

  cafemenunamedata: any;
  cafemenunames: cafemenunameInfo[] = [];

  constructor(
    private appConfigService: AppConfigService,
    private sesssionvalidator: SessionvalidateService,
    private EmployeeLoginService: EmployeeloginService,
    private router: Router,
    private CafeMenuNamesService: CafeMenuNamesService,
    private CafeMenuService: CafeMenuService
  ) {}

  ngOnInit(): void {
    this.imagepath = this.appConfigService.imagepath;
    this.employeeData = JSON.parse(localStorage.getItem('eeinfo') || '{}');
    if (this.employeeData?.EmployeeNo != undefined) {
      this.checkLogin();
    } else {
      this.validsession = this.sesssionvalidator.validate();
      if (this.validsession) {
        this.userdata = JSON.parse(localStorage.getItem('userinfo') || '{}');
        this.shpId = this.userdata?.shipid!;
        this.getCafeMenuNames();
      } else {
        this.router.navigate(['/login']);
      }
    }
  }

  checkLogin() {
    this.LoginData = this.EmployeeLoginService.GetEmployeeLogin(
      this.employeeData?.EmployeeNo,
      this.employeeData?.LastName
    ).subscribe((LoginData) => this.setCheckLogin(LoginData));
  }

  setCheckLogin(resdata: any) {
    this.LoginData = resdata;
    if (this.LoginData.GetEmployeeLogin.Result.Status != 'A') {
      this.router.navigate(['/adminlogin']);
    } else {
      this.validsession = this.sesssionvalidator.validate();
      if (this.validsession) {
        this.userdata = JSON.parse(localStorage.getItem('userinfo') || '{}');
        this.shpId = this.userdata?.shipid!;
        this.getCafeMenuNames();
      } else {
        this.router.navigate(['/shipselect']);
      }
    }
  }
  getCafeMenuNames() {
    this.cafemenunamedata = this.CafeMenuNamesService.getCafeMenuNames(
      this.shpId,
      this.ltyname
    ).subscribe((cafemenunamedata) => this.setCafeMenuNames(cafemenunamedata));
  }
  setCafeMenuNames(resdata: any) {
    this.cafemenunamedata = resdata;
    if (this.cafemenunamedata.GetCafeMenuNames.Result.Status == 'A') {
      this.cafemenunames =
        this.cafemenunamedata.GetCafeMenuNames.CafeMenuNamesList;
    }
  }
}
